module.exports = __webpack_public_path__ + "img/boxed-8.c5dfbd6f.jpg";